import { render } from "./NavigationBar.vue?vue&type=template&id=b533f526&scoped=true"
import script from "./NavigationBar.vue?vue&type=script&lang=js"
export * from "./NavigationBar.vue?vue&type=script&lang=js"

import "./NavigationBar.vue?vue&type=style&index=0&id=b533f526&scoped=true&lang=css"

import exportComponent from "/media/innovation/79c7daf6-b2a2-46d5-881e-4039c99a3fb61/home/innovation/Documents/project/pharmacy/connect to obr/terachpharmacy/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b533f526"]])

export default __exports__